import type { ReactNode } from "react";
import { InfoTip, type Spiegazione } from "./InfoTip";

/** Il contenitore di ogni blocco della BI: titolo, la sua «i», azioni a destra. */
export function Riquadro({
  titolo,
  spiegazione,
  azioni,
  children,
  className = "",
}: {
  titolo: string;
  spiegazione: Spiegazione;
  azioni?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      aria-label={titolo}
      className={`bi-entra min-w-0 rounded-[18px] border border-line bg-card p-5 max-md:rounded-[16px] max-md:p-4 ${className}`}
    >
      <header className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h2 className="font-display text-[18px] font-bold leading-tight tracking-[-0.01em]">
            {titolo}
          </h2>
          <InfoTip spiegazione={spiegazione} />
        </div>
        {azioni}
      </header>
      {children}
    </section>
  );
}

/** Interruttore a pillola per scegliere una vista dentro un riquadro. */
export function Pillole<T extends string>({
  valore,
  opzioni,
  onChange,
  etichetta,
}: {
  valore: T;
  opzioni: { id: T; nome: string }[];
  onChange: (v: T) => void;
  etichetta: string;
}) {
  return (
    <div
      role="group"
      aria-label={etichetta}
      className="flex w-max rounded-full border border-line-2 bg-paper p-0.5"
    >
      {opzioni.map((o) => (
        <button
          key={o.id}
          type="button"
          aria-pressed={valore === o.id}
          onClick={() => onChange(o.id)}
          className={`h-[28px] shrink-0 whitespace-nowrap rounded-full px-3 text-[12.5px] font-semibold transition-[background-color,color] duration-150 max-md:h-9 max-md:px-3.5 max-md:text-[14px] ${
            valore === o.id ? "bg-ink text-on-ink" : "text-ink hover:bg-paper-2"
          }`}
        >
          {o.nome}
        </button>
      ))}
    </div>
  );
}
